import { render, staticRenderFns } from "./contact-details.vue?vue&type=template&id=60e922d7&scoped=true"
import script from "./contact-details.vue?vue&type=script&lang=js"
export * from "./contact-details.vue?vue&type=script&lang=js"
import style0 from "./contact-details.vue?vue&type=style&index=0&id=60e922d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e922d7",
  null
  
)

export default component.exports